import * as React from 'react';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { BiCheck } from "react-icons/bi";
import { alpha, styled } from '@mui/material/styles';
import { TfiAngleDown } from "react-icons/tfi";

const icon = <img src='/images/empty.png' width="20" />;
const checkedIcon = <BiCheck size={20} color='#65707E'/>;
const CssTextField = styled(TextField)({
    '& label.Mui-focused': {
      color: '#38485D',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: 'green',
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#38485D',
        border: '1px solid #38485D',
        borderRadius: '8px',
      },
      '&:hover fieldset': {
        borderColor: '#38485D',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#38485D',
      },
      '&.MuiInputBase-root ': {
        background: '#F7F9FF',
      },
      '&.MuiOutlinedInput-root ': {
        paddingTop: '0px',
        paddingBottom: '0px',
        paddingleft: '6px',
        FontFace:'14px'
      },
    },
  });

export default function SimpleSelect(props) {
  return (
    <Autocomplete
      id="custom-autocomplete"
      popupIcon={<TfiAngleDown size={15} color="#38485D"/>}
      options={props.optiopnList}
      disableCloseOnSelect
      disableClearable
      getOptionLabel={(option) => option.title}
      onChange={(event, newValue) => {
        if(props.onChange){
          props.onChange(newValue)
        }
      }}
      renderOption={(props, option, { selected }) => (
        <li {...props} sx={{px:2}}>
          <Checkbox
            icon={icon}
            checkedIcon={checkedIcon}
            style={{ marginLeft: -6,marginRight: 8,padding:0 }}
            checked={selected}
          />
          {option.title}
        </li>
      )}
      style={{ width: '100%'}}
      renderInput={(params) => (
        <CssTextField {...params} sx={{pl:0}} placeholder="Select Background" />
      )}
    />
  );
}
